import { render, staticRenderFns } from "./LangSwitch.vue?vue&type=template&id=2878980d&scoped=true"
import script from "./LangSwitch.vue?vue&type=script&lang=js"
export * from "./LangSwitch.vue?vue&type=script&lang=js"
import style0 from "./LangSwitch.vue?vue&type=style&index=0&id=2878980d&prod&lang=less&scoped=true"
import style1 from "./LangSwitch.vue?vue&type=style&index=1&id=2878980d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878980d",
  null
  
)

export default component.exports